import { render, staticRenderFns } from "./PerformanceItem2020.vue?vue&type=template&id=4ca124e0&scoped=true&"
import script from "./PerformanceItem2020.vue?vue&type=script&lang=js&"
export * from "./PerformanceItem2020.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceItem2020.vue?vue&type=style&index=0&id=4ca124e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca124e0",
  null
  
)

export default component.exports